import React, { useMemo } from 'react';
import moment from 'moment';
import { Trans } from 'react-i18next';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getCallerObjectComponentFriendly } from 'flow/utils/ticket-utils';
import { makeSelectContactDataForNumber } from 'flow/selectors/contact-selectors';
import { selectUserCountryCode } from 'flow/selectors/ExtensionSelectors';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    callerNumber: string;
    callTimestamp: string;
}

const TicketCreateQueueCallInfo = ({ callerNumber, callTimestamp }: Props) => {
    const { i18next } = useAppContext();
    const ownCountryCode = useAppSelector(selectUserCountryCode);
    const selectContactData = useMemo(makeSelectContactDataForNumber, []);
    const callerContact = useAppSelector((state) =>
        selectContactData(state, callerNumber),
    );

    const callerObject = useMemo(
        () =>
            getCallerObjectComponentFriendly(
                callerContact,
                callerNumber,
                ownCountryCode,
                i18next,
            ),
        [callerContact, callerNumber, ownCountryCode, i18next],
    );

    return (
        <Trans
            i18n={i18next}
            i18nKey={'tickets.create.queue_call.call_info'}
            shouldUnescape={true}
            values={{
                caller: callerObject.displayString,
                date: moment(callTimestamp).format('MMMM Do, h:mm a'),
            }}
            components={[
                <strong
                    key="tcvqcm-caller"
                    className={
                        callerObject.formattingRequiresForcedLeftToRight
                            ? 'ltr'
                            : 'auto'
                    }
                />,
                <span key="tcvqcm-date" />,
            ]}
        />
    );
};

export default TicketCreateQueueCallInfo;
